export default __webpack_public_path__ + "11161784454a863163fbdde0d2554df2.png";